export const MANUAL_ENROLLMENT_SERVICE_NOW = 'manualEnrollmentServiceNow';
